import { useAppSelector } from '../../../redux';
import type TrailSurfaceTypeSegment from '../../../types/TrailSurfaceTypeSegment';
import useSvgImages from '../../../utils/useSvgImages';
import SurfaceTypePolyline from '../../Polyline/SurfaceTypePolyline';
import Markers from './Markers';
import { svgDefinitions } from './Segments';

type SurfaceTypeSegmentsProps = {
  hideArrows?: boolean;
  surfaceTypeSegments: TrailSurfaceTypeSegment[];
};

const SurfaceTypeSegments = ({ hideArrows, surfaceTypeSegments }: SurfaceTypeSegmentsProps) => {
  const segments = useAppSelector(state => state.customRoute.route.segments);
  const { imagesAreLoaded } = useSvgImages(svgDefinitions);

  if (!segments || !imagesAreLoaded) {
    return null;
  }

  return (
    <>
      <SurfaceTypePolyline hideArrows={hideArrows} segments={surfaceTypeSegments} />
      <Markers />
    </>
  );
};

export default SurfaceTypeSegments;
